<template>
    <div class="result-search">
        <!-- Note -->
        <p class="note">{{ t('accounts.invoices.resultSearch.note') }}</p>

        <!-- Download Button -->
        <div class="download-button-container">
            <div class="download-button-content" :class="{ mobile: getMobileAppState }">
                <icon-success class="icon-success"/>
                <div class="content">
                    <div class="label">{{ t('accounts.invoices.resultSearch.labelButton') }}</div>
                    <div class="description">{{description}}</div>
                </div>
                <!-- Desktop Download Button -->
                <button-tertiary
                icon="download"
                buttonSize="small"
                @clicked="downloadLink = generateInvoicingDownloadUrl(payloadResult)" />
            </div>
        </div>
        <!-- Component to handle download logic-->
        <download-logic-component
        :customSuccessMessage="t('accounts.invoices.resultSearch.customSuccessMessage')"
        :downloadLink="downloadLink"
        @clearDownloadLink="downloadLink = null"/>
    </div>
</template>

<script setup>
import IconSuccess from '@/assets/icons/check-circle.svg?inline'
import ButtonTertiary from '@/components/generic/buttons/Tertiary'
import DownloadLogicComponent from '@/components/generic/DownloadLogicComponent'

/* Vue */
import { ref, computed } from 'vue'
/* Assets and Helpers */
import { generateInvoicingDownloadUrl } from '@/network/api/invoicing.api.js'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* props received
@payloadResult { Object }
*/
const props = defineProps({
    formData: Object,
    payloadResult: Object
})

/* mapGetters */
const { getMobileAppState } = mapGetters()

const description = computed(() => {
    const endDateLastDay = new Date(props.formData.year, props.formData.endDate, 0).getDate()

    const beginDate = `01_${props.formData.beginDate}_${props.formData.year}`
    const endDate = `${endDateLastDay}_${props.formData.endDate}_${props.formData.year}`

    return t('accounts.invoices.resultSearch.descriptionButton', { date: `${beginDate} - ${endDate}` })
})

/* Data */
const downloadLink = ref(null)
</script>

<style lang="scss" scoped>
.result-search {
    width: 100%;
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid var(--secondary-light-2);

    .note {
        @include H6-Regular;
        line-height: 18px;
        color: var(--secondary-dark-2);

        margin-bottom: 24px;
    }

    .download-button-container {
        display: flex;
        align-items: center;

        width: 100%;
        height: 56px;
        background-color: var(--positive);

        padding: 0 8px 0 16px;
        border-radius: 8px;
        gap: 8px;

        border-radius: 8px;

        .download-button-content {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 8px;

            width: 100%;

            position: relative;

            .content {
                display: flex;
                flex-direction: column;
                align-items: flex-start;

                color: var(--secondary-light-4);

                .label {
                    @include H7-Medium;
                    line-height: 16px
                }

                .description {
                    @include H8-Regular;
                }
            }

            .tertiary-button-wrapper {
                flex-grow: 1;
                align-items: flex-end;
            }

            svg.icon-download {
                position: absolute;
                right: 28px;

                width: 16px;
                height: 16px;

                flex-shrink: 0;

                :deep(.change-color-fill) {
                    fill: var(--secondary-light-4);
                }
            }

            &.mobile {
                .content {
                    .label {
                        @include H6-Regular;
                        line-height: 18px
                    }

                    .description {
                        @include H7-Regular;
                    }
                }
            }
        }
    }

    svg.icon-success {
        width: 16px;
        height: 16px;

        flex-shrink: 0;

        :deep(.change-color-fill) {
            fill: var(--secondary-light-4);
        }
    }
}
</style>
